const SiteService = {};

SiteService.path = `${window.location.protocol+'//'+window.location.hostname}`;
if (!(window.location.protocol==='https:' && process.env.REACT_APP_APIPORT==='443')) SiteService.path+=process.env.REACT_APP_APIPORT;//dont add 443 port if https
SiteService.apiPath = `${window.location.protocol+'//'+window.location.hostname}:${process.env.REACT_APP_APIPORT}/api`;
SiteService.appName = process.env.REACT_APP_NAME;

SiteService.VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

SiteService.googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

SiteService.errorCodeReasons = {
	 400: 'Feil med inndata',
	 401: 'Ugyldig brukernavn eller passord',
	 403: 'Ugyldig brukernavn eller passord',
	 404: 'Siden finnes ikke',
	 500: 'Feil oppstod hos serveren',

}

SiteService.handleError = async (error) => {
	let message = "";
	if (error.reason){
		message = error.reason;
	} else if (SiteService.errorCodeReasons[error.code]) {
		message = SiteService.errorCodeReasons[error.code];
	}

	return message;
}

export default SiteService;